/**
 * design_handoff_accept_invitation §4 — screens 1/4 (Invitation). The
 * handoff shows different copy/right-pane for a new vs. an existing
 * address, but checkInvitation has no way to tell them apart in advance —
 * AcceptInvitationForm only discovers that when the Accept click itself is
 * attempted (success: 0 vs. a token). So this always renders the screen-1
 * variant; the existing-account "no password needed" promise is fulfilled
 * by the outcome (JoinedScreen) instead of a pre-click hint.
 *
 * @param {{name: string, icon?: string}} organization
 * @param {string=} inviterName
 * @param {string=} role
 * @param {string} invitedEmail
 * @param {boolean} loading
 * @param {string=} errorMessage
 * @param {function} onAccept
 * @param {function} onDecline
 */
import React from "react";
import { Button } from "../../theme/untitled";
import AuthAlert from "../AuthPages/AuthAlert";
import InvitationCard from "./InvitationCard";
import styles from "../AuthPages/authForm.module.scss";
import screenStyles from "./invitationScreens.module.scss";

const InvitationScreen = ({
  organization,
  inviterName,
  role,
  invitedEmail,
  loading,
  errorMessage,
  onAccept,
  onDecline,
}) => {
  const inviter = inviterName || "Someone";

  return (
    <div>
      <h1 className={styles.title}>Join {organization.name}</h1>
      <p className={styles.sub}>
        {inviter} invited you to work on this workspace's in Revisual.
      </p>

      <InvitationCard
        organization={organization}
        inviterName={inviterName}
        role={role}
        invitedEmail={invitedEmail}
      />

      <div className={screenStyles.actions}>
        <Button fullWidth loading={loading} onClick={onAccept}>
          Accept invitation
        </Button>

        {errorMessage && <AuthAlert variant="error">{errorMessage}</AuthAlert>}
      </div>

      <p className={styles.footQuestion}>
        Not expecting this?
        <button type="button" onClick={onDecline}>
          Decline invitation
        </button>
      </p>
    </div>
  );
};

export default InvitationScreen;
